<template>
  <ul id="chapters-list" class="custom-scrollbar" style="max-height: 100%; overflow-y: auto;">
    <li v-for="(chapter, index) in filteredChapters" :key="index"
        class="chapter-item list-group-item flex justify-between items-center p-3 border-b border-gray-800 rounded-md"
        :class="{ 'active': index === currentChapterIndex }"
        @click="$emit('play-chapter', getOriginalIndex(chapter))"
        :data-index="getOriginalIndex(chapter)">
      <div class="flex items-center">
        <span class="text-gray-400 w-8 text-center mr-4">{{ getOriginalIndex(chapter) + 1 }}</span>
        <span>{{ chapter }}</span>
      </div>
      <button class="play-chapter-btn text-gray-400 hover:text-white"><i class="fa-solid fa-play"></i></button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ChapterList',
  props: ['chapters', 'deployment_url', 'currentChapterIndex'],
  data() {
    return {
      searchQuery: ''
    };
  },
  computed: {
    filteredChapters() {
      if (!this.searchQuery) {
        return this.chapters;
      }
      return this.chapters.filter(chapter =>
          chapter.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    getOriginalIndex(chapterName) {
      return this.chapters.indexOf(chapterName);
    },
    scrollToActive() {
      this.$nextTick(() => {
        const newIndex = this.currentChapterIndex;
        if (newIndex < 0) return;
        const activeChapterElement = this.$el.querySelector(
            `.chapter-item[data-index='${newIndex}']`
        );

        if (activeChapterElement) {
          activeChapterElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    }
  },
  watch: {
    currentChapterIndex: {
      handler() {
        this.scrollToActive();
      }
    }
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #121212;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #777;
}

.chapter-item {
  cursor: pointer;
}

.chapter-item.active {
  background-color: rgba(255, 255, 255, 0.1);
  color: #34d399;
}

.chapter-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
</style>
